import authService from '@/services/authService'
import vuetify from '@/plugins/vuetify'

const state = {
  isCloudTask: true,
  isLoggedIn: false,
  language: '',
  hideNotificationsAlert: false,
  token: '',
  userKeybe: {},
  userKeybeTimeZone: {
    label: 'America/Bogota',
    offset: '−05:00'
  }
}

const mutations = {
  'CHANGE_KEYBE_AUTH' (state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn
  },
  'SET_CLOUDTASK' (state, value) {
    state.isCloudTask = true
  },
  'SET_DASHBOARD_LANGUAGE' (state, language) {
    state.language = language
  },
  'SET_KEYBE_USER' (state, userInfo) {
    state.userKeybe = userInfo
  },
  SET_KEYBE_USER_TIME_ZONE (state, userKeybeTimeZone) {
    state.userKeybeTimeZone = userKeybeTimeZone
  },
  'SET_HIDE_NOTIFICATIONS_ALERT' (state, value) {
    state.hideNotificationsAlert = value
  },
  'SET_TOKEN' (state, token) {
    state.token = token
  }
}

const actions = {
  async loginEmail ({ commit }, data) {
    try {
      const response = await authService.loginEmail(data)
      commit('SET_KEYBE_USER', response.user)
      commit('SET_TOKEN', response.token)
      commit('CHANGE_KEYBE_AUTH', true)
      return true
    } catch (e) {
      commit('SET_KEYBE_USER', {})
      commit('SET_TOKEN', '')
      commit('CHANGE_KEYBE_AUTH', false)
      throw e
    }
  },
  async loginPhone ({ commit }, data) {
    try {
      const response = await authService.loginPhone(data)
      commit('SET_KEYBE_USER', response.user)
      commit('SET_TOKEN', response.token)
      commit('CHANGE_KEYBE_AUTH', true)
      return true
    } catch (e) {
      commit('SET_KEYBE_USER', {})
      commit('SET_TOKEN', '')
      commit('CHANGE_KEYBE_AUTH', false)
      throw e
    }
  },
  logout ({ commit }) {
    commit('SET_SELECTED_COMPANY', {})
    commit('SET_SELECTED_APP', {})
    commit('SET_COMPANIES', [])
    commit('SET_APPS', [])
    commit('SET_APPS_STATISTICS', {})
    commit('SET_USERS', [])
    commit('SET_SEARCH_USERS', '')
    commit('SET_KEYBE_USER', {})
    commit('SET_TOKEN', '')
    commit('CHANGE_KEYBE_AUTH', false)
    commit('SET_TABLE_EDITING_MODE', false)
    vuetify.framework.theme.dark = false
  },
  async register ({ commit }, data) {
    try {
      const response = await authService.register(data)
      const token = response.token
      const user = response.user
      commit('SET_KEYBE_USER', user)
      commit('SET_TOKEN', token)
      commit('CHANGE_KEYBE_AUTH', true)
      return true
    } catch (e) {
      commit('SET_KEYBE_USER', {})
      commit('SET_TOKEN', '')
      commit('CHANGE_KEYBE_AUTH', false)
      throw e
    }
  },
  async registerEmail ({ commit }, data) {
    try {
      const response = await authService.registerEmail(data)
      const token = response.token
      const user = response.user
      commit('SET_KEYBE_USER', user)
      commit('SET_TOKEN', token)
      commit('CHANGE_KEYBE_AUTH', true)
      return true
    } catch (e) {
      commit('SET_KEYBE_USER', {})
      commit('SET_TOKEN', '')
      commit('CHANGE_KEYBE_AUTH', false)
      throw e
    }
  },
  async registerEmailInvitation ({ commit }, data) {
    try {
      const response = await authService.registerEmailInvitation(data)
      const token = response.token
      const user = response.user
      commit('SET_KEYBE_USER', user)
      commit('SET_TOKEN', token)
      commit('CHANGE_KEYBE_AUTH', true)
      return true
    } catch (e) {
      commit('SET_KEYBE_USER', {})
      commit('SET_TOKEN', '')
      commit('CHANGE_KEYBE_AUTH', false)
      throw e
    }
  },
  async resetPasswordEmail (vuexContext, data) {
    await authService.resetPasswordEmail(data)
    return true
  },
  async resetPasswordPhone (vuexContext, data) {
    await authService.resetPasswordPhone(data)
    return true
  },
  async resetPasswordValidation (vuexContext, data) {
    await authService.resetPasswordValidation(data)
    return true
  }
}

const getters = {
  isLoggedIn (state) {
    return state.isLoggedIn
  },
  isAdmin (state, getters) {
    return getters.administratorRoles.includes('ROLE_ADMIN')
  },
  isSuperAdmin (state) {
    return state.userKeybe.type === 'superadmin'
  },
  userKeybeExtraData (state) {
    return state.userKeybe.extraData || {}
  },
  userType (state) {
    return state.userKeybe.type
  },
  token (state) {
    return state.token
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
